import React from 'react'
import * as Yup from 'yup'
import Dialog from '@material-ui/core/Dialog'
import DialogTitle from '@material-ui/core/DialogTitle'
import DialogContent from '@material-ui/core/DialogContent'
import { useMutation } from '@apollo/react-hooks'
import { useSnackbar } from 'notistack'
import {
  CLONE_USER_IMAGE_TEMPLATE,
  CLONE_USER_VIDEO_TEMPLATE
} from '../../graphql/userTemplates'
import CredentialsForm from '../CredentialsForm'

const ShareDialog = ({ open, onClose, userTemplateId, type, name }) => {
  const { enqueueSnackbar } = useSnackbar()
  const inputFields = [{ label: 'Email', name: 'email', type: 'text' }]
  const [shareTemplate, { loading }] = useMutation(
    type?.typeName === 'UserImageTemplate'
      ? CLONE_USER_IMAGE_TEMPLATE
      : CLONE_USER_VIDEO_TEMPLATE,
    {
      onCompleted: () => {
        onClose()
      },
      onError: () => {
        enqueueSnackbar('User does not exist', {
          variant: 'error'
        })
      }
    }
  )
  const validationSchema = Yup.object().shape({
    email: Yup.string().email('Invalid Email').required('Email is required')
  })
  const initialValues = {
    email: ''
  }

  const handleSubmit = async (values) => {
    await shareTemplate({
      variables: {
        id: userTemplateId,
        name,
        ...values
      }
    })
    onClose()
  }

  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>Share Template</DialogTitle>
      <DialogContent>
        <CredentialsForm
          inputFields={inputFields}
          validationSchema={validationSchema}
          initialValues={initialValues}
          handleSubmit={handleSubmit}
          submitText='Confirm'
          loading={loading}
        />
      </DialogContent>
    </Dialog>
  )
}

export default ShareDialog
